import { useSelector } from 'react-redux';

import { Flex } from '@opendoor/bricks/core';

import InputQuestion from 'src/components/sellerFlow/InputQuestion';
import { RootState } from 'src/store';
import { getCurrentSlug } from 'src/store/router/selectors';
import {
  getAnswers,
  answersErrors as getAnswersErrors,
  getCurrentPageError,
} from 'src/store/sellerFlow/selectors';

const FlowQuestions = () => {
  const answers = useSelector(getAnswers);

  // TODO: follow up on these - we don't really show errors currently since our
  // UI does automatic inline validation usually
  const answersErrors = useSelector(getAnswersErrors);
  const currentPageError = useSelector(getCurrentPageError);

  const title = useSelector((state: RootState) => state.ui.page?.title);
  const questions = useSelector((state: RootState) => state.ui.page?.questions);
  const currentSlug = useSelector(getCurrentSlug);

  return (
    <Flex justifyContent="center">
      <Flex
        flexDirection="column"
        minWidth="325px"
        width={['100%', currentSlug === 'phone' ? '600px' : 'unset']}
      >
        {questions
          ?.filter((q) => !q.hidden)
          .map((question) => {
            const key = question.key;
            const errorMessageMap = answersErrors.get(key);
            return (
              <InputQuestion
                key={key}
                answers={answers}
                errorMessage={errorMessageMap && errorMessageMap.get('message')}
                showInfoCard
                pageHasError={!!currentPageError}
                // TODO - fix this typing
                question={question as any}
                questionTitle={title ?? ''}
              />
            );
          })}
      </Flex>
    </Flex>
  );
};

export default FlowQuestions;
